var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#BDFF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 16.25H23.875C23.9439 16.25 24 16.3061 24 16.375C24 16.4439 23.9439 16.5 23.875 16.5H16.375C16.3061 16.5 16.25 16.4439 16.25 16.375C16.25 16.3061 16.3061 16.25 16.375 16.25Z",
    fill: "#282828",
    stroke: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 18.25H16.375C16.03 18.25 15.75 18.53 15.75 18.875C15.75 19.22 16.03 19.5 16.375 19.5H21.375C21.72 19.5 22 19.22 22 18.875C22 18.53 21.72 18.25 21.375 18.25Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 12H14.5C13.1212 12 12 13.1212 12 14.5V27C12 27.2425 12.14 27.4637 12.36 27.5662C12.4437 27.605 12.535 27.625 12.625 27.625C12.7688 27.625 12.9112 27.575 13.025 27.48L16.6013 24.5H25.75C27.1287 24.5 28.25 23.3787 28.25 22V14.5C28.25 13.1212 27.1287 12 25.75 12ZM27 22C27 22.6888 26.44 23.25 25.75 23.25H16.375C16.2288 23.25 16.0875 23.3013 15.975 23.395L13.25 25.6662V14.5C13.25 13.8112 13.81 13.25 14.5 13.25H25.75C26.44 13.25 27 13.8112 27 14.5V22Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17C29.155 17 28.875 17.28 28.875 17.625C28.875 17.97 29.155 18.25 29.5 18.25C30.19 18.25 30.75 18.8112 30.75 19.5V30.0737L28.64 28.3863C28.53 28.2987 28.3912 28.25 28.25 28.25H19.5C18.81 28.25 18.25 27.6888 18.25 27V26.375C18.25 26.03 17.97 25.75 17.625 25.75C17.28 25.75 17 26.03 17 26.375V27C17 28.3787 18.1212 29.5 19.5 29.5H28.03L30.9838 31.8637C31.0975 31.9537 31.2362 32 31.375 32C31.4663 32 31.5588 31.98 31.6462 31.9388C31.8625 31.8338 32 31.615 32 31.375V19.5C32 18.1212 30.8787 17 29.5 17Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8c121ac651e7a2ed54c39c10e00a261c.svg";
export { ForwardRef as ReactComponent };